import * as Actions from 'reducks/storeShipping/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreShippingReducer = (state = initialState.storeShipping, action: any) => {
  switch (action.type) {
    case Actions.FETCH_STORE_SHIPPINGS:
      return {
        ...state,
        shippings: [...action.payload],
      }
    case Actions.INIT_STORE_SHIPPINGS:
      return {
        shippings: [],
        is_set_unsubscribe: false,
        unsubscribes: [],
      }
    case Actions.INIT_STORE_SHIPPING_UNSUBSCRIBES:
      return {
        ...state,
        is_set_unsubscribe: false,
        unsubscribes: [],
      }
    case Actions.SET_STORE_SHIPPING_UNSUBSCRIBES:
      return {
        ...state,
        is_set_unsubscribe: true,
        unsubscribes: [...action.payload],
      }
    default:
      return state
  }
}
